const DEVICE_ID_KEY = "aethercv-device-id";

const generateRandomHex = (size) => {
  const bytes = new Uint8Array(size);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < size; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
};

const generateDeviceId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  const timePart = Date.now().toString(36);
  return `dev_${timePart}_${generateRandomHex(12)}`;
};

const hashFNV1a = (value) => {
  let hash = 2166136261;
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
};

export const getDeviceFingerprint = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") return null;
  const nav = window.navigator || {};
  const screen = window.screen || {};
  const timeZone =
    typeof Intl !== "undefined" && Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone || ""
      : "";
  const parts = [
    nav.userAgent || "",
    nav.platform || "",
    nav.language || "",
    String(nav.hardwareConcurrency || ""),
    String(nav.deviceMemory || ""),
    String(nav.maxTouchPoints || ""),
    String(screen.width || ""),
    String(screen.height || ""),
    String(screen.colorDepth || ""),
    timeZone || "",
  ];
  const raw = parts.join("|");
  if (!raw.replace(/\|/g, "")) return null;
  return `fp_${hashFNV1a(raw)}`;
};

export const getDeviceId = () => {
  if (typeof window === "undefined" || !window.localStorage) return null;
  let deviceId = window.localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = generateDeviceId();
    try {
      window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
    } catch {
      return null;
    }
  }
  return deviceId;
};
